import React from 'react';
import PropTypes from 'prop-types';
import NextEvent from './NextEvent';

const WhatsNext = ({ nextEvents }) => {
  const { header, events, eventsAreOptions } = nextEvents;
  const numberHeadings = eventsAreOptions && events.length > 1;
  const eventsList = events.map((event, index) => (
    <NextEvent
      key={event.title}
      title={
        numberHeadings ? `Option ${index + 1}: ${event.title}` : event.title
      }
      description={event.description}
    />
  ));

  return (
    <div>
      <h2>What happens next?</h2>
      <p>{header}</p>
      {/* list-style-type: none on appeals-next-list strips the <ul>'s
      implicit list role in Safari/VoiceOver, so role="list" restores it. */}
      {/* eslint-disable-next-line jsx-a11y/no-redundant-roles */}
      <ul className="appeals-next-list" role="list">
        {eventsList}
      </ul>
    </div>
  );
};

WhatsNext.propTypes = {
  nextEvents: PropTypes.shape({
    header: PropTypes.string.isRequired,
    eventsAreOptions: PropTypes.bool,
    events: PropTypes.arrayOf(
      PropTypes.shape({
        title: PropTypes.string.isRequired,
        description: PropTypes.element.isRequired,
      }),
    ).isRequired,
  }).isRequired,
};

export default WhatsNext;
